import type { RedemittelLabelContent } from "../content-types";
import { Explanation, Prompt } from "./shared";
import { PickButtons } from "./drill-helpers";
import type { QuestionRendererProps } from "./types";

/** Classify each sentence's communicative intention (mirrors iOS
 *  RedemittelLabelView: pick the function label per item). */
export function RedemittelLabelRenderer({ content, answer, setAnswer, revealed }: QuestionRendererProps) {
  const c = content as unknown as RedemittelLabelContent;
  const items = c.items ?? [];
  const map = (answer as Record<string, string>) ?? {};
  return (
    <div>
      <Prompt>{c.prompt}</Prompt>
      <div className="mt-4 space-y-3">
        {items.map((it) => (
          <div key={it.id} className="rounded-xl bg-slate-50 p-3">
            <div className="mb-2 text-sm text-ink">{it.sentence}</div>
            <PickButtons
              options={c.tray_labels ?? []}
              chosen={map[it.id]}
              correct={it.function_label}
              revealed={revealed}
              onPick={(v) => setAnswer({ ...map, [it.id]: v })}
            />
            {revealed && map[it.id] && map[it.id] !== it.function_label && it.near_miss_rationale && (
              <p className="mt-1.5 text-xs text-ink-faint">{it.near_miss_rationale}</p>
            )}
          </div>
        ))}
      </div>
      {revealed && <Explanation text={c.explanation} />}
    </div>
  );
}
